'use client';

import { c as _c } from "react/compiler-runtime";
import { agreeToCookies } from '@/app/lib/consent';
import { IconSize } from '@diamond-block/ui';
import { useTranslations } from 'next-intl';
import { TbCheck, TbInfoCircle } from 'react-icons/tb';
export const CookieBanner = t0 => {
  const $ = _c(3);
  const {
    cookiesAccepted
  } = t0;
  const t = useTranslations("CookieBanner");
  let t1;
  if ($[0] !== cookiesAccepted || $[1] !== t) {
    t1 = !cookiesAccepted && <div className="alert fixed right-4 bottom-4 z-50 mx-auto max-w-lg"><TbInfoCircle size={IconSize.alert} className="min-h-8" /><span>{t("we-use-cookies")}</span><button className="btn btn-ghost btn-sm" onClick={_temp}><TbCheck size={IconSize.btnSm} />{t("ok")}</button></div>;
    $[0] = cookiesAccepted;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
function _temp() {
  return agreeToCookies();
}